<!--
  @description: 财务结算-开票注册-商品信息
  @filePath:src\modules\transport\bms\views\finance\invoiceRegistration\components\GoodsInfo\index.vue
-->
<template>
    <div>
        <m-pane
            ref="goodsInfoTable"
            class="goodsInfoTable"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="vehicleFreePlatform"
            :currentPage="currentPage"
            @search-btn="queryList"
            @row-db-click="handleRowDBClick"
            @add-btn="handleAdd"
            @edit-btn="handleEdit"
            @del-btn="handleDelete"
            @pageChange="handlePageChange"
            @sizeChange="handleSizeChange"
            @selectChange="handleSelectChange"
        ></m-pane>
        <operate-dialog ref="goodsInfoOperate"  @addSuccess="handleSearchChange" />
    </div>
</template>
<script>

import mPane from '@/modules/transport/bms/components/Table/Index.vue';
import OperateDialog from './OperateDialog.vue';
import mTableMixin from '@/modules/transport/bms/mixins/mTableMixin.js';
import config from './config.js';
import { queryProductInfo, delProductInfo } from '@/modules/transport/bms/api/invoiceRegistrationApi.js';
export default {
    name: 'GoodsInfo',
    mixins: [mTableMixin],
    components: { mPane, OperateDialog },
    props: {
        jobId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            config,
            num: 0
        };
    },
    methods: {
        // 查询
        queryListExecute({ params, successCallback }) {
            if (!this.jobId) {
                this.num && this.$message.warning('没有销方信息');
                this.num++;
                return;
            }
            this.loading = true;
            params = {
                ...params,
                'sourceJobId': this.jobId
            };
            queryProductInfo(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(el => {
                        el.id = el.jobId;
                        el.invoiceProductName = `*${el.taxShortName || ''}*${el.productName || ''}`;
                    });
                    successCallback(res);
                }
            }).finally(() => { this.loading = false; });
        },
        // 新增
        handleAdd() {
            if (!this.jobId) {
                this.$message.warning('没有销方信息，不可新增');
                return;
            }
            this.$refs.goodsInfoOperate.handleVisible(true, { sourceJobId: this.jobId }, this.totalData);
        },
        // 编辑
        handleEdit(row) {
            this.$refs.goodsInfoOperate.handleVisible(true, row, this.totalData);
        },
        // 删除
        deleteTableConfirmExecute({ params, confirmFn, successCallback }) {
            confirmFn().then(() => {
                delProductInfo(params.ids).then(res => {
                    if (res && +res.code === 0) {
                        successCallback();
                    }
                });
            });
        }
    }
};
</script>